/* Lightweight theme-native offers; Shopify remains authoritative for prices and cart state. */
(function(){
 'use strict';
 const data=document.getElementById('NCBundleData');
 if(!data||!window.NCBundleRules||!window.NCCartTransaction)return;
 let config;try{config=JSON.parse(data.textContent);}catch{return;}
 const rules=window.NCBundleRules, base=(window.Shopify?.routes?.root||'/');
 const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:config.currency||'AUD',currencyDisplay:'narrowSymbol',maximumFractionDigits:n%100===0?0:2}).format(n/100);
 const read=(store,key,fallback)=>{try{return JSON.parse(window[store].getItem(key))??fallback;}catch{return fallback;}};
 const write=(store,key,value)=>{try{window[store].setItem(key,JSON.stringify(value));}catch{}};
 let dismissed=read('sessionStorage','nc-dismissed-rules',[]), cart=null, busy=false,refreshPromise=null;
 let dismissedCart=read('sessionStorage','nc-dismissed-cart',null);
 let reminderShown=read('sessionStorage','nc-reminder-shown',false),reminderTimer=null;
 const initial=document.querySelector('[data-nc-initial-cart]');
 try{cart=JSON.parse(initial?.textContent||'null');}catch{}
 async function request(path,body){
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
  try{
  const response=await fetch(base+path,{signal:controller.signal,method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:body?JSON.stringify(body):undefined});
  const value=await response.json();
  if(!response.ok||value.status>=400)throw new Error(value.description||value.message||'Shopify could not update your bag. Please try again.');
  return value;
  }finally{clearTimeout(timer);}
 }
 function emit(name,details){
  if(config.designMode)return;
  const consent=window.Shopify?.customerPrivacy;
  if(!consent?.analyticsProcessingAllowed?.())return;
  const event={...details,currency:config.currency};
  window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:name,...event});
  try{window.Shopify?.analytics?.publish?.(name,event);}catch{}
 }
 function refresh(){
  if(refreshPromise)return refreshPromise;
  refreshPromise=request('cart.js').then(value=>{cart=value;renderAll();return value;}).finally(()=>refreshPromise=null);
  return refreshPromise;
 }
 function renderAll(){document.querySelectorAll('nc-bundle-offer').forEach(el=>el.render());}
 let lastQualified=null;
 function shipping(host,current){
  const old=host.querySelector('[data-nc-shipping]');if(old)old.hidden=true;
  const boxes=document.querySelectorAll('[data-nc-cart-shipping]');
  const exactMarket=(config.currency==='AUD'&&config.country!=='US')||(config.currency==='USD'&&config.country==='US');
  const allowed=(config.shippingVerified||config.shippingPreview)&&exactMarket&&config.shippingCountries?.includes(config.country);
  const total=current?.total_price||0;
  const exception=config.country==='AU'&&config.currency==='AUD'&&(total===6000||total===6001);
  const gap=exception?0:Math.max(0,config.threshold-total),qualified=gap===0;
  boxes.forEach(box=>{box.hidden=!allowed;if(!allowed)return;
   box.querySelector('[data-nc-shipping-label]').textContent=gap?"You're "+money(gap)+' away from free shipping.':'Free shipping unlocked.';
   const progress=box.querySelector('progress');progress.max=config.threshold;progress.value=Math.min(config.threshold,current?.total_price||0);box.dataset.qualified=String(qualified);
   if(lastQualified===false&&qualified){box.classList.remove('nc-unlocked');requestAnimationFrame(()=>box.classList.add('nc-unlocked'));}
  });
  if(allowed)lastQualified=qualified;
 }
 function offerText(offer){
  const r=offer.rule;
  if(r.kind==='saving')return 'The same pieces, together for '+money(offer.product.price)+'.';
  if(r.kind==='add')return r.to==='duo'?'Add a matching plate and bowl. '+money(offer.product.price)+' for the pair.':'Add '+offer.product.title+' for '+money(offer.product.price)+'.';
  return 'Add '+offer.missing.join(' and ').replace(/^Meridian /,'the Meridian ')+' for '+money(offer.delta)+' more.';
 }
 function sectionNames(){
  return ['cart-drawer','cart-icon-bubble',document.querySelector('cart-items')?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-',''),document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean);
 }
 function renderSections(sections){
  const itemsId=document.querySelector('cart-items')?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-',''),footerId=document.querySelector('#main-cart-footer')?.dataset.id;
  const itemsHtml=sections?.[itemsId]||sections?.['main-cart-items'],footerHtml=sections?.[footerId]||sections?.['main-cart-footer'];
  if(!sections||!sections['cart-drawer'])throw new Error('Your bag changed, but its display could not refresh.');
  const drawer=document.querySelector('cart-drawer');
  if(drawer){
   drawer.renderContents({sections});
   drawer.classList.toggle('is-empty',cart.items.length===0);
  }
  if(itemsHtml){
   const page=new DOMParser().parseFromString(itemsHtml,'text/html');
   const current=document.querySelector('cart-items'),fresh=page.querySelector('cart-items');
   if(current&&fresh)current.innerHTML=fresh.innerHTML;
  }
  if(footerHtml){
   const page=new DOMParser().parseFromString(footerHtml,'text/html');
   const current=document.getElementById('main-cart-footer'),fresh=page.getElementById('main-cart-footer');
   if(current&&fresh)current.innerHTML=fresh.innerHTML;
  }
 }
 async function reconcile(){
  cart=await request('cart.js');
  const url=new URL(window.location.href);url.searchParams.set('sections',sectionNames().join(','));
  const response=await fetch(url.pathname+url.search,{credentials:'same-origin',cache:'no-store'});
  if(!response.ok)throw new Error('Please refresh your bag to see its latest contents.');
  renderSections(await response.json());renderAll();return cart;
 }
 function setBusy(value){
  busy=value;document.body.classList.toggle('nc-cart-busy',value);
  document.querySelectorAll('[data-nc-accept]').forEach(b=>b.disabled=value);
  document.querySelectorAll('[name="checkout"]').forEach(b=>{if(value){b.dataset.ncWasDisabled=String(b.disabled);b.disabled=true;}else if(b.dataset.ncWasDisabled!==undefined){b.disabled=b.dataset.ncWasDisabled==='true';delete b.dataset.ncWasDisabled;}});
 }
 function showError(surface,message){
  document.querySelectorAll('nc-bundle-offer').forEach(el=>{if(el.dataset.surface===surface||el.dataset.surface==='cart'){const box=el.querySelector('[data-nc-error]');box.textContent=message;box.hidden=false;}});
 }
 async function accept(host){
  if(busy||!host.offer)return;
  const selected=host.offer,surface=host.dataset.surface;
  let committed=false;
  setBusy(true);host.querySelector('[data-nc-error]').hidden=true;
  try{
   const result=await window.NCCartTransaction.run({cart,selected,config,dismissed,request,reconcile,sections:sectionNames()});
   cart=result.cart;const confirmed=result.offer;committed=true;
   renderSections(result.sections);hideReminder(false);
   emit('bundle_offer_accepted',{rule_id:confirmed.rule.id,surface,cart_value_before:confirmed.before,cart_value_after:cart.total_price,delta:cart.total_price-confirmed.before});
   renderAll();
   document.querySelector('cart-drawer .drawer__heading')?.setAttribute('tabindex','-1');
   document.querySelector('cart-drawer .drawer__heading')?.focus();
  }catch(error){
   // Transactions reconcile failures; a failed section render also needs a fresh display.
   if(committed){try{await reconcile();}catch{showError(surface,'Your bag changed. Refresh the page to see its latest contents.');return;}}
   renderAll();
   showError(surface,error.name==='AbortError'?'The connection took too long. Review your bag before trying again.':error.message||'Please review your bag and try again.');
  }finally{setBusy(false);}
 }
 async function changeCode(code){
  if(busy)return;setBusy(true);
  const status=message=>{const box=document.querySelector('.nc-cart-discount');if(box){box.open=true;box.querySelector('[data-nc-code-status]').textContent=message;box.querySelector('[data-nc-clear-code]').hidden=!(cart?.discount_codes||[]).some(d=>d.applicable);}};
  try{
   // Shopify decides eligibility and combination; preserve other accepted codes.
   const fresh=await request('cart.js');
   const codes=code?[...new Set([...(fresh.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code),code])]:[];
   const result=await request('cart/update.js',{discount:codes.join(','),sections:sectionNames(),sections_url:location.pathname});
   cart=await request('cart.js');renderSections(result.sections);renderAll();
   const applied=code&&(cart.discount_codes||[]).some(d=>d.applicable&&d.code.toLowerCase()===code.toLowerCase());
   status(code?(applied?'Discount applied.':'That code is not eligible for this cart. Your existing eligible offers remain.'): 'Discount code removed.');
  }catch(error){try{await reconcile();}catch{}status('We could not confirm the code change. Review your cart and try again.');}
  finally{setBusy(false);}
 }
 document.addEventListener('submit',event=>{if(!event.target.matches('[data-nc-discount-form]'))return;event.preventDefault();const code=new FormData(event.target).get('discount')?.trim();if(code)changeCode(code);});
 document.addEventListener('click',event=>{if(event.target.closest('[data-nc-clear-code]'))changeCode('');});
 class NCBundleOffer extends HTMLElement{
  connectedCallback(){this.render();}
  render(){
   if(!cart)return;
   shipping(this,cart);
   this.offer=rules.fingerprint(cart)===dismissedCart?null:rules.evaluate(cart,config,dismissed);
   const box=this.querySelector('[data-nc-offer]');box.hidden=!this.offer;
   if(!this.offer)return;
   const o=this.offer,r=o.rule;
   this.querySelector('[data-nc-heading]').textContent=r.kind==='saving'?'The same pieces. A better price.':config.copy[r.kind==='add'&&r.to==='duo'?'guest':r.to]||'Make it a set.';
   this.querySelector('[data-nc-copy]').textContent=offerText(o);
   this.querySelector('[data-nc-saving]').textContent=r.kind==='saving'?'Save '+money(o.saving)+' on the pieces in your bag.':r.kind==='add'?'Save '+money(o.listSaving)+' vs individual pieces.':'Save '+money(o.saving)+' compared with adding the matching pieces.';
   const img=this.querySelector('[data-nc-image]');img.hidden=!o.product.image;if(o.product.image){img.src=o.product.image;img.alt=o.product.title;}
   this.querySelector('[data-nc-accept]').textContent=(r.kind==='saving'?'Switch to ':r.kind==='add'?'Add ':'Upgrade to ')+o.product.title+' · '+money(o.product.price);
   const saving=this.querySelector('[data-nc-saving]');saving.hidden=r.kind==='add'&&o.listSaving<=0;
   const delivery=this.querySelector('[data-nc-delivery]');
   const qualifies=config.shippingVerified&&((config.currency==='AUD'&&config.country!=='US')||(config.currency==='USD'&&config.country==='US'))&&config.shippingCountries?.includes(config.country)&&o.after>=config.threshold;
   delivery.hidden=!qualifies;
   if(qualifies){
    const shippingCost=config.country==='US'?1500:config.country==='AU'?config.domesticShipping:config.internationalShipping;
    delivery.textContent=cart.total_price<config.threshold&&r.kind!=='saving'?'About '+money(Math.max(0,o.delta-shippingCost))+' more delivered'+(config.country==='AU'?' in Australia':config.country==='US'?' in the US':'')+', with free shipping.':'Free shipping.';
   }
   this.track();
  }
  track(){
   if(!this.offer||this.closest('[hidden]'))return;
   if(this.dataset.surface==='cart'&&!this.closest('cart-drawer')?.classList.contains('active'))return;
   const key=this.offer.rule.id+':'+this.offer.before;
   if(this.shownKey===key)return;this.shownKey=key;
   emit('bundle_offer_shown',{rule_id:this.offer.rule.id,surface:this.dataset.surface,cart_value:cart.total_price});
  }
 }
 customElements.define('nc-bundle-offer',NCBundleOffer);
 // Delegate owned controls so Shopify/app section replacements cannot drop listeners.
 document.addEventListener('click',event=>{
  const button=event.target.closest?.('[data-nc-accept],[data-nc-dismiss]');
  const host=button?.closest('nc-bundle-offer');if(!host)return;
  event.preventDefault();event.stopPropagation();
  if(button.hasAttribute('data-nc-accept')){accept(host);return;}
  if(!host.offer)return;const id=host.offer.rule.id;
  dismissedCart=rules.fingerprint(cart);write('sessionStorage','nc-dismissed-cart',dismissedCart);
  dismissed=[...new Set([...dismissed,id])];write('sessionStorage','nc-dismissed-rules',dismissed);
  emit('bundle_offer_dismissed',{rule_id:id,surface:host.dataset.surface});
  if(host.dataset.surface==='reminder')hideReminder(true);renderAll();
 },true);
 const reminder=document.querySelector('[data-nc-reminder]');
 function hideReminder(dismiss){
  if(!reminder)return;reminder.hidden=true;
  if(dismiss){write('localStorage','nc-reminder-dismissed-at',Date.now());const o=reminder.querySelector('nc-bundle-offer')?.offer;if(o)emit('bundle_offer_dismissed',{rule_id:o.rule.id,surface:'reminder'});}
 }
 function showReminder(){
  if(!reminder||config.designMode||!config.reminders||reminderShown||busy||document.hidden)return;
  if(Date.now()-read('localStorage','nc-reminder-dismissed-at',0)<86400000)return;
  if(!cart?.items?.length||cart.total_price>=config.threshold||config.currency!=='AUD')return;
  if(document.querySelector('cart-drawer.active,dialog[open],.menu-drawer-container[open], [role="dialog"][aria-label="POPUP Form"]'))return;
  if(rules.fingerprint(cart)===dismissedCart||!rules.evaluate(cart,config,dismissed))return;
  reminderShown=true;write('sessionStorage','nc-reminder-shown',true);reminder.hidden=false;reminder.querySelector('nc-bundle-offer')?.track();
 }
 reminder?.querySelector('[data-nc-reminder-close]')?.addEventListener('click',()=>hideReminder(true));
 document.addEventListener('nc:cart-open',()=>{clearTimeout(reminderTimer);hideReminder(false);refresh().catch(()=>{});document.querySelectorAll('nc-bundle-offer').forEach(el=>el.track());});
 document.addEventListener('nc:cart-close',()=>{clearTimeout(reminderTimer);reminderTimer=setTimeout(showReminder,1800);});
 document.addEventListener('mouseout',event=>{if(!event.relatedTarget&&event.clientY<=0&&matchMedia('(hover:hover)').matches)showReminder();});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&reminder&&!reminder.hidden)hideReminder(true);});
 if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{if(!busy)return refresh().catch(()=>{});});
 window.addEventListener('pageshow',event=>{if(event.persisted)refresh().catch(()=>{});});
 document.addEventListener('shopify:section:load',()=>renderAll());
 class NCCollection extends HTMLElement{
  connectedCallback(){
   this.cards=Array.from(this.querySelectorAll('.nc-card'));this.filter='all';
   this.querySelectorAll('[data-nc-group]').forEach(group=>{if(!group.querySelector('.nc-card'))group.hidden=true;});
   this.querySelectorAll('[data-filter]').forEach(link=>link.addEventListener('click',event=>{
    const filter=link.dataset.filter;
    if(filter!=='all'&&!this.cards.some(c=>c.dataset.ncType===filter))return;
    event.preventDefault();this.filter=filter;this.apply();
   }));
   this.querySelector('[data-nc-sort]').addEventListener('change',()=>this.apply());
   if(location.hash==='#singles')this.filter='singles';
   this.apply();
  }
  apply(){
   const sort=this.querySelector('[data-nc-sort]').value,sorted=this.querySelector('[data-nc-sorted-grid]');
   const cards=this.cards.filter(c=>this.filter==='all'||c.dataset.ncType===this.filter);
   this.querySelectorAll('[data-filter]').forEach(link=>link.setAttribute('aria-current',link.dataset.filter===this.filter?'page':'false'));
   this.querySelector('[data-nc-count]').textContent=cards.length+' products';
   this.cards.forEach(c=>c.hidden=!cards.includes(c));
   if(sort==='featured'){
    sorted.hidden=true;
    this.cards.forEach(c=>this.querySelector('[data-nc-grid="'+c.dataset.ncType+'"]')?.append(c));
    this.querySelectorAll('[data-nc-group]').forEach(group=>group.hidden=!(this.filter==='all'||this.filter===group.dataset.ncGroup)||!group.querySelector('.nc-card'));
   }else{
    this.querySelectorAll('[data-nc-group]').forEach(group=>group.hidden=true);sorted.hidden=false;
    cards.sort((a,b)=>sort==='title-ascending'?a.dataset.ncTitle.localeCompare(b.dataset.ncTitle):(Number(a.dataset.ncPrice)-Number(b.dataset.ncPrice))*(sort==='price-descending'?-1:1));
    cards.forEach(c=>sorted.append(c));
   }
  }
 }
 customElements.define('nc-collection',NCCollection);
 renderAll();
})();
